import styled from 'styled-components'




export const Card = styled.div`
  position: relative;
  background: white;
  border-radius: 6px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  &:hover{
    box-shadow: 0px 10px 10px rgba(0,0,0,0.15)
  }
  
`

export const ImageContent = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 70%;
  position: relative;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`



export const Content  = styled.div`
  padding: 1rem;
  min-height: 11rem;
`

export const Title = styled.div`
  color: ${props => props.theme.colors.primary};
  font-weight: 400;
  font-size: 1.25rem;
  margin-bottom: .25rem;
`

export const Date = styled.div`
  color: ${props => props.theme.colors.thirdary};
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Text = styled.div`
  color: ${props => props.theme.colors.black.primary};
  font-weight: 300;
`

export const VideoButtonWrapper = styled.div`
  margin-bottom: 1rem;

`
export const CtaWrapper = styled.div`
  button {
    padding: 0;
    margin-bottom: 1rem;
    color: ${props => props.theme.colors.thirdary};
  }
`